import actionConsts from 'constants/actions';
import { getUniqueItemsOnly } from 'util/functions.js'

const initialState = {
	sevenDaysRestrictedActionsList: [], // Storyline 1: 7-day
    tenDaysRestrictedActionsList: [], // Storyline 1: 10-day
	twoDaysRestrictedActionsList: [],       // Storyline 2: 2-day
	threeDaysRestrictedActionsList: [],     // Storyline 2: 3-day
	fiveDaysRestrictedActionsList: [],      // Storyline 2: 5-day
	sevenDaysRestrictedActionsList2: [],    // Storyline 2: 7-day
	tenDaysRestrictedActionsList2: [],      // Storyline 2: 10-day
	fifteenDaysRestrictedActionsList: [],   // Storyline 2: 15-day
	twentyDaysRestrictedActionsList: [],    // Storyline 2: 20-day
	permanentDisabledActionList: [],
	disabledActionActorObj: {},
};

const findActionIdOfOption = (actionOptionId, isDelayedAction, actionOptionsList) => {
	for(let i = 0 ; i < actionOptionsList.length; i++){
		if(actionOptionsList[i].id == actionOptionId){
			if([2,8,9,10,16].includes(actionOptionsList[i].actionId) && !isDelayedAction){
				//Case where this is response of a delayed action, hence avoiding repetition of 
				return -1;
			}else{
				return actionOptionsList[i].actionId;
			}
		}
	}
	return -1;
}

const calculateActionFrequency = (payload) => {
	let actionOptionsTakenList = payload.actionOptionsTakenList;
	actionOptionsTakenList.sort((a, b) => {
		return a.day - b.day;
	});
	let actionOptionsList = payload.actionOptionsList;
	let actionFrequency = {};
	let actionLastTakenDay = {};
	let noOfSuccessAction2 = 0;
	let isActionOption8 = false;
	
	for (let eachActionOptionTaken = 0; eachActionOptionTaken < actionOptionsTakenList.length; eachActionOptionTaken++) {
		const takenAction = actionOptionsTakenList[eachActionOptionTaken];
		let actionID = findActionIdOfOption(
			takenAction.actionOptionId, 
			takenAction.isDelayedAction, 
			actionOptionsList
		);
		
		//Creating and populating actionFrequency
		if(actionFrequency[actionID]){
			actionFrequency[actionID] = actionFrequency[actionID] + 1;
		}else{
			actionFrequency[actionID] = 1;
		}

		//Creating and populating actionLastTakenDay
		if(!actionLastTakenDay[actionID]){
			actionLastTakenDay[actionID] = takenAction.day;
		}else if(actionLastTakenDay[actionID] < takenAction.day){
			actionLastTakenDay[actionID] = takenAction.day;
		}

		//Allowing Change Policy 3 times successfull
		if(actionOptionsTakenList[eachActionOptionTaken].actionOptionId == 8 &&
			actionOptionsTakenList[eachActionOptionTaken].isDelayedAction)
		{
			noOfSuccessAction2++;
		}
		if(noOfSuccessAction2 >= 3){
			isActionOption8 = true;
		}
	}
	return { actionFrequency, actionLastTakenDay, isActionOption8 }
}

const calculateIsSuccessDisabling = (payload) => {
	let actionOptionsTakenList = payload.actionOptionsTakenList;
	actionOptionsTakenList.sort((a, b) => {
		return a.day - b.day;
	});
	let actionOptionsList = payload.actionOptionsList;
	let actionActorToDisable = {};
	let actorsOfaction14 = {};
	let actorsOfaction10 = {};
	let actorsOfaction34 = {};
	for (let eachActionOptionTaken = 0; eachActionOptionTaken < actionOptionsTakenList.length; eachActionOptionTaken++) {
		let actionID = findActionIdOfOption(
			actionOptionsTakenList[eachActionOptionTaken].actionOptionId, 
			actionOptionsTakenList[eachActionOptionTaken].isDelayedAction, 
			actionOptionsList
		);
		if ([6, 7, 21].includes(actionID) && actionOptionsTakenList[eachActionOptionTaken].response.responseType == 'SUCCESS'){
			if(actionActorToDisable[actionID]){
				if(! actionActorToDisable[actionID].includes(actionOptionsTakenList[eachActionOptionTaken].response.actorIds[0]) ){
					actionActorToDisable[actionID].push(actionOptionsTakenList[eachActionOptionTaken].response.actorIds[0]);
				}
			}else{
				actionActorToDisable[actionID] = actionOptionsTakenList[eachActionOptionTaken].response.actorIds;
			}
		}
		if ([19].includes(actionID) && actionOptionsTakenList[eachActionOptionTaken].response.responseType == 'PRELAG'){
			if(actionActorToDisable[actionID]){
				if(! actionActorToDisable[actionID].includes(actionOptionsTakenList[eachActionOptionTaken].response.actorIds[0]) ){
					actionActorToDisable[actionID].push(actionOptionsTakenList[eachActionOptionTaken].response.actorIds[0]);
				}
			}else{
				actionActorToDisable[actionID] = actionOptionsTakenList[eachActionOptionTaken].response.actorIds;
			}
		}
		if ([14].includes(actionID)){
			let currentActor = actionOptionsTakenList[eachActionOptionTaken].response.actorIds[0];
			if(actorsOfaction14[currentActor]){
				actorsOfaction14[currentActor] = actorsOfaction14[currentActor] + 1;
			}else{
				actorsOfaction14[currentActor] = 1;
			}
		}
		if ([10].includes(actionID) && actionOptionsTakenList[eachActionOptionTaken].isDelayedAction){
			let currentActorsFor10 = actionOptionsTakenList[eachActionOptionTaken].response.actorIds;
			currentActorsFor10.map((eachActor)=>{
				if(actorsOfaction10[eachActor]){
					actorsOfaction10[eachActor] = actorsOfaction10[eachActor] + 1;
				}else{
					actorsOfaction10[eachActor] = 1;
				}
			})
		}
		if ([34].includes(actionID)) {
			let currentActor = actionOptionsTakenList[eachActionOptionTaken].response.actorIds[0];
			if(actorsOfaction34[currentActor]){
				actorsOfaction34[currentActor] = actorsOfaction34[currentActor] + 1;
			}else{
				actorsOfaction34[currentActor] = 1;
			}
		}
	}

	//Disabling actors for Kickstart Innovation after action on them twice
	for(let actors in actorsOfaction14){
		if(actorsOfaction14[actors] >= 2){
			if(actionActorToDisable[14]){
				if(! actionActorToDisable[14].includes(actors) ){
					actionActorToDisable[14].push(+actors);
				}
			}else{
				actionActorToDisable[14] = [+actors];
			}
		}
	}

	//Disabling actors for Share Webinars after action on them thrice
	for(let actors in actorsOfaction10){
		if(actorsOfaction10[actors] >= 3){
			if(actionActorToDisable[10]){
				if(! actionActorToDisable[10].includes(actors) ){
					actionActorToDisable[10].push(+actors);
				}
			}else{
				actionActorToDisable[10] = [+actors];
			}
		}
	}

	//Disabling actors for Catalog Assets after action on them 3 times
	for(let actors in actorsOfaction34){
		if(actorsOfaction34[actors] >= 3){
			if(actionActorToDisable[34]){
				if(! actionActorToDisable[34].includes(actors) ){
					actionActorToDisable[34].push(+actors);
				}
			}else{
				actionActorToDisable[34] = [+actors];
			}
		}
	}
	return actionActorToDisable;
}

const updateDisabledActors = (disabledActionActorObj, actionId, actorsSelected) => {
	if(disabledActionActorObj[actionId]){
		disabledActionActorObj[actionId].push(actorsSelected[0]);
	}else{
		disabledActionActorObj[actionId] = actorsSelected;
	}

	return disabledActionActorObj;
}

const updateDisabledActorsWithBadge = (disabledActionActorObj, actionId, actorsSelected) => {
	disabledActionActorObj[actionId] = actorsSelected;
	return disabledActionActorObj;
}

const updateDisabledSuccessfulCondition = (disabledActionActorObj, actionActorToDisable) => {
	for (let keys in actionActorToDisable) {
		disabledActionActorObj[keys] = actionActorToDisable[keys];
	}
	return disabledActionActorObj;
}

const restrictions = (state = initialState, action = {}) => {
	switch (action.type) {
		case 'SET_INIT_DATA':{
			return {
				...state,
				disabledActionActorObj: action.payload.reduxData["DISABLE_ACTION_ACTOR"] || state.disabledActionActorObj
			};
		}
		case 'UPDATE_RESTRICTIONS':{
			let currentDay = action.payload.currentDay;
			let { actionFrequency, actionLastTakenDay, isActionOption8} = calculateActionFrequency(action.payload);
			let actionMaxedOut = [];
			let actionTemp7Restricted = [];
            let actionTemp10Restricted = [];
			let actionTemp2Restricted = [];
			let actionTemp3Restricted = [];
			let actionTemp5Restricted = [];
			let actionTemp7Restricted2 = [];
			let actionTemp10Restricted2 = [];
			let actionTemp15Restricted = [];
			let actionTemp20Restricted = [];


			//Handing special case of Action 2 ActionOption 8
			if(isActionOption8){
				actionMaxedOut.push(2);
			}

			//<Action ids> here in Disabling logic is hardcoded
			//TODO: Recieve Disabling logic from backend and store in redux
			for(const actions in actionFrequency){
				// ========== STORYLINE 1: Banking-Digital_Platform ==========
				if([8].includes(parseInt(actions,10)) && actionFrequency[actions] >= 7){
					actionMaxedOut.push(parseInt(actions,10));
				}
				if([3].includes(parseInt(actions,10)) && actionFrequency[actions] >= 1){
					actionMaxedOut.push(parseInt(actions,10));
				}
				// if([4].includes(parseInt(actions,10)) && actionFrequency[actions] >= 3){
				// 	actionMaxedOut.push(parseInt(actions,10));
				// }
				if([15].includes(parseInt(actions,10)) && actionFrequency[actions] >= 15){
					actionMaxedOut.push(parseInt(actions,10));
				}

				// ========== STORYLINE 2: AI-BLUR ==========  
				
				// Present Case - max 9 times
				if([34].includes(parseInt(actions,10)) && actionFrequency[actions] >= 9){
    				actionMaxedOut.push(parseInt(actions,10));
				}
				// RunPilot - max 3 times
				if([41].includes(parseInt(actions,10)) && actionFrequency[actions] >= 3){
					actionMaxedOut.push(parseInt(actions,10));
				}
				// Build Networks (Crowdsource Ideas) - max 4 times per BU
				if([50].includes(parseInt(actions,10)) && actionFrequency[actions] >= 4){
					actionMaxedOut.push(parseInt(actions,10));
				}
				// Revise Protocols - max 4 times  
				if([51].includes(parseInt(actions,10)) && actionFrequency[actions] >= 4){
    				actionMaxedOut.push(parseInt(actions,10));
				}
				// PublishDashboard - max 3 times
				if([53].includes(parseInt(actions,10)) && actionFrequency[actions] >= 3){
					actionMaxedOut.push(parseInt(actions,10));
				}
				
			}	
			// Check restrictions for actions that have been taken
			for(const actions in actionLastTakenDay){
				const actionId = parseInt(actions,10);
				const daysSinceLastTaken = currentDay - actionLastTakenDay[actions];
				
				// ========== STORYLINE 1: Banking-Digital_Platform ==========
				// 7-day wait time restrictions (existing logic)
				if([1,5,9,12,20].includes(actionId) && 
				   daysSinceLastTaken < 7){
					actionTemp7Restricted.push(actionId);
				}
				// 10-day wait time restrictions (existing logic)
				if([2,4].includes(actionId) && 
				   daysSinceLastTaken < 10){
					actionTemp10Restricted.push(actionId);
				}
				
				// ========== STORYLINE 2: AI-BLUR ==========
				// 2-day wait time restrictions
				if([43].includes(actionId) && 
				   daysSinceLastTaken < 2){
					actionTemp2Restricted.push(actionId);
				}
				// 3-day wait time restrictions
				if([38].includes(actionId) && 
				   daysSinceLastTaken < 3){
					actionTemp3Restricted.push(actionId);
				}
				// 5-day wait time restrictions
				if([35,36,37,44,47,49,52,54].includes(actionId) && 
				   daysSinceLastTaken < 5){
					actionTemp5Restricted.push(actionId);
				}
				// 7-day wait time restrictions
				if([34, 48].includes(actionId) && 
				   daysSinceLastTaken < 7){
					actionTemp7Restricted2.push(actionId);
				}
				// 10-day wait time restrictions
				if([41,45,51].includes(actionId) && 
				   daysSinceLastTaken < 10){
					actionTemp10Restricted2.push(actionId);
				}
				// 15-day wait time restrictions  
				if([40].includes(actionId) && 
				   daysSinceLastTaken < 15){
					actionTemp15Restricted.push(actionId);
				}
				// 20-day wait time restrictions
				if([39].includes(actionId) && 
				   daysSinceLastTaken < 20){
					actionTemp20Restricted.push(actionId);
				}
			}	

			let newMaxedOut = getUniqueItemsOnly(actionMaxedOut, state.permanentDisabledActionList)

			return{
				...state,
				permanentDisabledActionList: [...state.permanentDisabledActionList, ...newMaxedOut],
				sevenDaysRestrictedActionsList: [...actionTemp7Restricted],
                tenDaysRestrictedActionsList: [...actionTemp10Restricted],
				twoDaysRestrictedActionsList: [...actionTemp2Restricted],
				threeDaysRestrictedActionsList: [...actionTemp3Restricted],
				fiveDaysRestrictedActionsList: [...actionTemp5Restricted],
				sevenDaysRestrictedActionsList2: [...actionTemp7Restricted2],
				tenDaysRestrictedActionsList2: [...actionTemp10Restricted2],
				fifteenDaysRestrictedActionsList: [...actionTemp15Restricted],
				twentyDaysRestrictedActionsList: [...actionTemp20Restricted],
			};
		}

		case 'UPDATE_ACTIONS_MAXEDOUT':{
			let disabledActors = action.payload.disabledActors;
			let actionMaxedOut = [];

			for(const actions in disabledActors){
				if([6, 7, 14, 17, 19, 21].includes(parseInt(actions,10)) && disabledActors[actions].length >= 3){
					actionMaxedOut.push(parseInt(actions,10));
				}
				if([18].includes(parseInt(actions,10)) && disabledActors[actions].length >= 9){
					actionMaxedOut.push(parseInt(actions,10));
				}
				if([10].includes(parseInt(actions,10)) && disabledActors[actions].length >= 4){
					actionMaxedOut.push(parseInt(actions,10));
				}
				if([37].includes(parseInt(actions,10)) && disabledActors[actions].length >= 4){
					actionMaxedOut.push(parseInt(actions,10));
				}
				if([38].includes(parseInt(actions,10)) && disabledActors[actions].length >= 3){
					actionMaxedOut.push(parseInt(actions,10));
				}
				if([40].includes(parseInt(actions,10)) && disabledActors[actions].length >= 3){
					actionMaxedOut.push(parseInt(actions,10));
				}
				if([42].includes(parseInt(actions,10)) && disabledActors[actions].length >= 4){
					actionMaxedOut.push(parseInt(actions,10));
				}
				if([50].includes(parseInt(actions,10)) && disabledActors[actions].length >= 4){
					actionMaxedOut.push(parseInt(actions,10));
				}
			}

			let newMaxedOut = getUniqueItemsOnly(actionMaxedOut, state.permanentDisabledActionList)

			return{
				...state,
				permanentDisabledActionList: [...state.permanentDisabledActionList,...newMaxedOut]
			}
		}

		case 'UPDATE_DISABLED_ACTORS_NO_CONDITION':{
			let actorsSelected = action.payload.actorsSelected;
			let actionId = action.payload.actionId;
			return{
				...state,
				disabledActionActorObj: updateDisabledActors(state.disabledActionActorObj, actionId, actorsSelected)
			};
		}

		case 'UPDATE_DISABLED_ACTORS_BUILD_NETWORK':{
			let actorsSelected = action.payload.actorsSelected;
			let actionId = action.payload.actionId;
			return{
				...state,
				disabledActionActorObj: updateDisabledActorsWithBadge(state.disabledActionActorObj, actionId, actorsSelected)
			};
		} 

		case 'UPDATE_DISABLED_ACTORS_RECOGNITION':{
			let actorsSelected = action.payload.actorsSelected;
			let actionId = action.payload.actionId;
			return{
				...state,
				disabledActionActorObj: updateDisabledActorsWithBadge(state.disabledActionActorObj, actionId, actorsSelected)
			};
		}

		case 'UPDATE_DISABLED_ACTORS_SUCCESSFUL_CONDITION':{
			let actionActorToDisable = calculateIsSuccessDisabling(action.payload);
			return{
				...state,
				disabledActionActorObj: updateDisabledSuccessfulCondition(state.disabledActionActorObj, actionActorToDisable)
			}
		}

		default:
			return state;
	}
};

export default restrictions;